import './AppRoadMap.scss';
import { useEffect } from 'react';
import Status from '../../assets/images/Shape.png';
// import useHandleAnchorClick from '../../hooks/useHandleAnchorClick';
import { useTranslation } from 'react-i18next';
const quartersRef: any[] = [];

const AppRoadMap = () => {
  const getTranslation = (key, language) => {
    const translations = {
      Released: {
        fr: 'Déployé',
        en: 'Released'
      },
      'Release Note': {
        fr: 'Note de mise à jour',
        en: 'Release Note'
      },
      Upcoming: {
        fr: 'À venir',
        en: 'Upcoming'
      }
    };
    return translations[key][language] || translations[key]['en'];
  };

  const { t, i18n } = useTranslation();

  const ariaLabel = getTranslation('Released', i18n.language);

  // const handleAnchorClick = useHandleAnchorClick();

  // to get current quarter of year
  let today = new Date();
  const currQuarter = Math.floor((today.getMonth() + 3) / 3);

  // scrolling the current quarter into view
  useEffect(() => {
    const scrollToCurrentQuarter = () => {
      if (quartersRef.length >= currQuarter) {
        const el = quartersRef[quartersRef.length - 1].getBoundingClientRect();

        const mobile = el.width > 300 ? el.top - 150 : el.top - 300;

        window.screen.width > 900
          ? window.scrollBy(0, el.top - 300)
          : window.scrollBy(0, mobile);
      }
    };
    scrollToCurrentQuarter();
    const timeOutId = setTimeout(scrollToCurrentQuarter, 200);
    return () => clearTimeout(timeOutId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currQuarter, quartersRef]);

  const quarters: any = [];
  const data = t('roadmap_releases', {
    returnObjects: true,
    defaultValue: []
  } as any);

  if (Array.isArray(data)) {
    data?.forEach(
      (t) => !quarters.includes(t['quarter']) && quarters.push(t.quarter)
    );
  }
  let i = 0;

  const updateQuarterRefs = (el) => {
    if (quartersRef.length === quarters.length - 1) {
      quartersRef.push(el);
    } else {
      quartersRef.push(el);
    }
  };

  const removePTags = (str?: string): string => {
    if (!str) {
      return '';
    }
    return str.replace(/^<p>/, '').replace(/<\/p>$/, '');
  };

  const convertToHtmlTags = (input?: string): string => {
    if (!input) {
      return '';
    }
    const textArea = document.createElement('textarea');
    textArea.innerHTML = input;
    return textArea.value;
  };

  const addAriaLabelToLinks = (htmlContent) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
  
    const links = doc.querySelectorAll('a');
  
  
    links.forEach((link) => {
      const anchorText = link.textContent;  

      if (!link.hasAttribute('aria-label')) {
        link.setAttribute('aria-label', `Read ${anchorText}`);
      }
    });
  
    return doc.body.innerHTML;
  };

  return (
    <div>
      {Array.isArray(data) &&
        data?.map((item) => {
          i++;
          return (
            <div key={`Q${item.quarter}-${item.year}-R${i}`}>
              {(item.quarter.includes('Q') ||
                item.quarter.includes('T') ||
                item.quarter.includes('H') ||
                item.quarter.includes('S')) && (
                <div
                  className={`roadMapContainer ${item.quarter} ${item.year}`}
                  ref={(el) => item.roadmapId && updateQuarterRefs(el)}
                >
                  {item.roadmapId && (
                    <div
                      className={`year ${
                        item.roadmapId.toString() !== '1' && 'sectionSpacer'
                      } ${item.quarter}`}
                      aria-label={`you are currently in ${item.quarter}`}
                    >
                      {item.quarter}
                      <span aria-hidden="true">-</span>
                      {item.year}
                    </div>
                  )}
                  <div className={`roadMapBody ${item.quarter}`}>
                    <span className={`circle ${item.quarter}`}>
                      <span className={`innerCirlce ${item.quarter}`}></span>
                    </span>
                    <div className="content">
                      <div className="bookingStatus quarters">
                        <div className="status">
                          {item?.checkbox_image === 'Yes' && (
                            <img
                              src={Status}
                              alt="release notes icon"
                              aria-label={ariaLabel}
                              className="statusIcon"
                            ></img>
                          )}
                          <h2 className="title Q1">
                            {/* <span>Read release notes for </span> */}
                            <span
                              dangerouslySetInnerHTML={{
                                __html: addAriaLabelToLinks(removePTags(item?.paymentType))
                              }}
                              // onClick={handleAnchorClick}
                            />{' '}
                          </h2>
                        </div>
                        <div
                          className={`option Q1 ${
                            item.bookingType ===
                              'PRIME BOOKING and POST-BOOKING' && 'bookingBtn'
                          }`}
                        >
                          {item.bookingType}
                        </div>
                      </div>
                      <div
                        className="description"
                        dangerouslySetInnerHTML={{
                          __html: item?.paymentDescription
                            ? item.paymentDescription
                            : ''
                        }}
                      ></div>
                    </div>
                  </div>
                </div>
              )}

              {item.quarter === 'Upcoming Enhancements' && (
                <div className="roadMapContainer upcomingEnhancements">
                  {item.quarter === 'Upcoming Enhancements' &&
                    item.roadmapId && (
                      <div
                        className="year upcomingEnhancements sectionSpacer"
                        aria-label="you are currently in upcomingEnhancements"
                      >
                        {getTranslation('Upcoming', i18n.language)}{' '}
                      </div>
                    )}
                  <div className="roadMapBody upcomingEnhancements">
                    <span className="circle upcomingEnhancements">
                      <span className="innerCirlce upcomingEnhancements"></span>
                    </span>
                    <div className="content">
                      <div className="bookingStatus upcomingEnhancements">
                        <div className="status upcomingEnhancements">
                          <h2 className="title upcomingEnhancements">
                            {' '}
                            <div
                              dangerouslySetInnerHTML={{
                                __html: removePTags(
                                  convertToHtmlTags(item?.paymentType)
                                )
                              }}
                            ></div>{' '}
                          </h2>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
    </div>
  );
};
export default AppRoadMap;
